
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"down\" ><title>Operation Icons Copy 4</title><path d=\"M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.071-.282 2.496l11.37 10.793-.04.039 2.088 2.196 1.098-1.043 12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "down");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/down.svg
// module id = 488
// module chunks = 0 1